<script setup lang="ts">
import { useState } from '#app'
import { getByPath, inject, setByPath } from '#imports'
import { onMounted, ref, toRaw } from 'vue'
import { useChooseFile } from '~/layers/cms/app/composables/chooseFile'
import { useChoosePage } from '~/layers/cms/app/composables/choosePage'
import { getcurrentChosenElement, update_cms_values, getcurrentChosenElementDefaults } from '~/layers/cms/app/plugins/cms-custom-component'
import type { CmsCustomComponentType, CmsData, CustomComponentValue } from '~/layers/cms/app/types/cmsTypes'

const component_values = ref<CmsCustomComponentType>()

const { chooseFile } = useChooseFile()

const swapFilePath = async (variable: CustomComponentValue) => {
  const newSrc = await chooseFile()
  if (newSrc) {
    variable.value = newSrc
  }
}
const cmsData = useState<CmsData>('cmsData')
const elem_defaults = ref<CmsCustomComponentType>()
const path = ref<string[]>([])

onMounted(() => {
  const element = getcurrentChosenElement()
  const defaults = getcurrentChosenElementDefaults() as CmsCustomComponentType
  if (!element || !defaults) return

  elem_defaults.value = structuredClone(toRaw(defaults))
  path.value = [...element, 'component_data']

  const data = getByPath(cmsData.value, element)
  const dataComponentData = toRaw(data?.component_data) as CmsCustomComponentType | undefined

  component_values.value = structuredClone({
    ...toRaw(defaults),
    ...dataComponentData,
  })

  console.log(component_values.value === toRaw(getByPath(cmsData.value, element)?.component_data))

})

const { choosePage } = useChoosePage()

const chooseLinkFromSites = async (value: CustomComponentValue) => {
  const newSrc = await choosePage()
  if (newSrc) {
    value.value = newSrc
  }
}
const dialogRef = inject<DialogRef>('dialogRef')
interface DialogRef {
  value: {
    data: {
      defaultGroup: string
    }
    close(): void
  }
}

const closeDialog = () => {
  if (!dialogRef) return
  dialogRef.value.close()
}

const save = () => {
  if (!component_values.value) return
  const snapshot = structuredClone(toRaw(component_values.value))
  setByPath(cmsData.value, path.value, snapshot)
  update_cms_values(snapshot)
  closeDialog()
}
</script>

<template>
  <div class="flex flex-col gap-6 p-4">
    <div>
      <Button
        label="Zapisz"
        icon="pi pi-save"
        size="small"
        severity="success"
        @click="save"
      />
    </div>
    <div
      v-for="(cos, index) in component_values"
      :key="index"
      class="flex flex-col gap-2"
    >
      <label
        :for="'input-' + index"
        class="text-sm font-bold text-surface-700 dark:text-surface-0/80"
      >
        {{ cos.setting_label }}
      </label>

      <div class="flex items-center w-full gap-3">
        <div
          v-if="cos.settingType === 'link'"
          class="flex w-full gap-2"
        >
          <InputText
            :id="'input-' + index"
            v-model="(cos.value as string)"
            class="flex-auto"
            placeholder="Wpisz adres URL..."
          />
          <Button
            icon="pi pi-link"
            severity="secondary"
            @click="chooseLinkFromSites(cos)"
          />
        </div>

        <Select
          v-else-if="cos.settingType === 'select'"
          :id="'input-' + index"
          v-model="(cos.value as string)"
          :options="cos.selectValues"
          class="w-full"
        />

        <InputText
          v-else-if="cos.settingType === 'text'"
          :id="'input-' + index"
          v-model="(cos.value as string)"
          class="w-full"
        />

        <div
          v-else-if="cos.settingType === 'color'"
          class="flex items-center gap-3 p-2 border rounded-lg border-surface-300 dark:border-surface-700"
        >
          <input
            v-model="cos.value"
            type="color"
            class="w-8 h-8 border-none cursor-pointer bg-transparent"
          >
          <span class="font-mono text-sm uppercase">{{ cos.value }}</span>
        </div>

        <ToggleSwitch
          v-else-if="cos.settingType === 'boolean'"
          v-model="cos.value"
        />

        <div
          v-else-if="cos.settingType === 'image'"
          class="relative group"
        >
          <NuxtImg
            :src="(cos.value as string)"
            class="w-32 h-32 object-cover rounded-lg border border-surface-300 dark:border-surface-700 cursor-pointer hover:opacity-80 transition-opacity"
            width="128"
            height="128"
            loading="lazy"
            format="webp"
            alt="image"
            quality="100"
            @click="swapFilePath(cos)"
          />
          <div class="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity">
            <i class="pi pi-pencil text-white bg-black/50 p-2 rounded-full" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
